var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'seat-info block-info seat-component ' + _vm.seatClass},[(_vm.isSelected)?_c('span',{staticClass:"seat-info-initials"},[_vm._v(_vm._s(_vm.displayPassengerInitials))]):(_vm.isBlocked)?_c('vb-icon',{attrs:{"name":"seat_blocked"}}):(
      !_vm.isSelected &&
      _vm.isAvailable &&
      _vm.isSuitableForInfant &&
      (!_vm.isHovered || _vm.price === 0)
    )?_c('vb-icon',{staticClass:"seat-info-price",attrs:{"name":"seat_best_for_infant","color":_vm.sass('primary'),"size":20}}):(
      !_vm.isSelected &&
      _vm.isAvailable &&
      _vm.price !== 0 &&
      (!_vm.isSuitableForInfant || _vm.isHovered)
    )?_c('span',{staticClass:"seat-info-price"},[_c('span',[_vm._v(_vm._s(_vm.formattedPrice))]),_c('span',{staticClass:"d-none d-xl-inline d-lg-inline"},[_vm._v(_vm._s(_vm.currencySymbol))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }